
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 180 140"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2165","stroke-width":"10"}},[_c('g',{attrs:{"data-name":"Rectangle 3316","transform":"translate(30)"}},[_c('rect',{attrs:{"width":"120","height":"20","rx":"10"}}),_c('rect',{attrs:{"x":"5","y":"5","width":"110","height":"10","rx":"5","fill":"none"}})]),_c('g',{attrs:{"data-name":"Rectangle 3317","transform":"translate(30 120)"}},[_c('rect',{attrs:{"width":"120","height":"20","rx":"10"}}),_c('rect',{attrs:{"x":"5","y":"5","width":"110","height":"10","rx":"5","fill":"none"}})]),_c('g',{attrs:{"data-name":"Rectangle 3318","transform":"translate(0 60)"}},[_c('rect',{attrs:{"width":"180","height":"20","rx":"10"}}),_c('rect',{attrs:{"x":"5","y":"5","width":"170","height":"10","rx":"5","fill":"none"}})])])])
          )
        }
      }
    